import ErrorPageTemplate from '@cohort/wallet/components/ErrorPageTemplate';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import React from 'react';
import {useTranslation} from 'react-i18next';

const EmbedSessionLostPage: React.FC = () => {
  const {t} = useTranslation('pages', {keyPrefix: 'embedSessionLostPage'});
  const merchant = useMerchantContext();

  return (
    <ErrorPageTemplate title={t('title')} description={t('description')} merchant={merchant} />
  );
};

export default EmbedSessionLostPage;
